import {
  benefitUtils,
  blogUtils,
  businessUtils,
  companyUtils,
  employerUtils,
  recipeUtils,
  restaurantUtils,
} from "../../../utils/entityUtils";

export const prepareSearchResults = (searchResults, entityCategories, entityTags, userLocation) => {
  //prepare entities
  searchResults.restaurants = prepareRestaurants(searchResults.restaurants, entityCategories, entityTags, userLocation);

  searchResults.businesses = prepareBusinesses(searchResults.businesses, entityCategories, entityTags, userLocation);

  searchResults.recipes = prepareRecipes(searchResults.recipes, entityCategories, entityTags, userLocation);
  if (searchResults.benefits) {
    //we got benefits from ES
  } else {
    searchResults.benefits = prepareBenefits(searchResults.restaurants, searchResults.businesses);
  }
  searchResults.companies = prepareCompanies(searchResults.companies, entityCategories, entityTags, userLocation);

  searchResults.blogs = prepareBlogs(searchResults.blogs, entityCategories, entityTags, userLocation);

  searchResults.employers = prepareEmployers(searchResults.employers, entityCategories, entityTags, userLocation);
};

export const prepareSearchResultsArray = (resultsArray, entityCategories, entityTags, userLocation) => {
  for (const result of resultsArray) {
    switch (result.item.entity_type) {
      case "restaurant":
        // prettier-ignore
        result.item = restaurantUtils.prepareRestaurant(result.item, entityCategories.restaurants, entityTags, userLocation);
        break;
      case "business":
        // prettier-ignore
        result.item = businessUtils.prepareBusinessBranch(result.item, entityCategories.businessesSubs, entityTags, userLocation, entityCategories.businesses);
        break;
      case "recipe":
        result.item = recipeUtils.prepareRecipe(result.item, entityCategories.recipes);
        break;
      case "benefit":
        result.item = benefitUtils.prepareBenefit(result.item, userLocation.coords);
        break;
      case "company":
        // prettier-ignore
        result.item = companyUtils.prepareCompany(result.item, entityCategories.companiesSubs, entityTags, userLocation);
        break;
      case "blog":
        result.item = blogUtils.prepareBlog(result.item, entityCategories.blogs, entityTags, userLocation);
        break;
      case "employer":
        // prettier-ignore
        result.item.employer = employerUtils.prepareEmployer(result.item.employer, entityCategories.employers, entityTags, userLocation);
        break;
      default:
        console.warn(
          `Unknown entity type '${result.item.entity_type}' in prepareSearchResultsArray. entity:`,
          result.item
        );
    }
  }
};

const prepareRestaurants = (restaurants, entityCategories, entityTags, userLocation) => {
  if (restaurants) {
    return restaurants.map((restaurant) =>
      restaurantUtils.prepareRestaurant(
        restaurant,
        entityCategories.restaurants,
        entityTags,
        userLocation
      )
    );
  }
  return restaurants;
};

const prepareBusinesses = (businesses, entityCategories, entityTags, userLocation) => {
  if (businesses) {
    const branches = businessUtils.prepareBusinessBranchesList(businesses);

    return branches.map((businessBranch) =>
      businessUtils.prepareBusinessBranch(
        businessBranch,
        entityCategories.businessesSubs,
        entityTags,
        userLocation,
        entityCategories.businesses
      )
    );
  }
  return [];
};

const prepareRecipes = (recipes, entityCategories) => {
  if (recipes) {
    return recipes.map((recipe) => recipeUtils.prepareRecipe(recipe, entityCategories.recipes));
  }
  return recipes;
};

const prepareBenefits = (restaurants, businesses) => {
  return benefitUtils.prepareBenefitsList(restaurants, businesses);
};

const prepareCompanies = (companies, entityCategories, entityTags, userLocation) => {
  if (companies) {
    return companies.map((company) =>
      companyUtils.prepareCompany(company, entityCategories.companiesSubs, entityTags, userLocation)
    );
  }
  return companies;
};


const prepareBlogs = (blogs, entityCategories, entityTags, userLocation) => {
  if (blogs) {
    return blogs.map((blog) =>
      blogUtils.prepareBlog(blog, entityCategories.blogs, entityTags, userLocation)
    );
  }
  return blogs;
};

const prepareEmployers = (employers, entityCategories, entityTags, userLocation) => {
  if (employers) {
    return employers.map((employer) =>
  
      employerUtils.prepareEmployer(employer, entityCategories.employers, entityTags, userLocation)
    );
  }
  return employers;
};
